export default __webpack_public_path__ + "6c9aef3d3491588a2af925ec1b35fcbc.svg";